import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/services/api.service";
import { ServiceProviderService } from "./services/service-provider.service";
import endpoints from "src/app/helpers/endpoints";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fury-service-providers",
  templateUrl: "./service-providers.component.html",
  styleUrls: ["./service-providers.component.scss"],
})
export class ServiceProvidersComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  states = [];
  constructor(
    private apiservice: ApiService,
    private serviceProviderService: ServiceProviderService
  ) {}

  ngOnInit(): void {
    this.getAllStates();
  }
  getAllStates() {
    this.apiservice
      .get(
        `${endpoints.state.getAllState}?page=1&size=9999&searchBy=title&searchType=startsWith`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.serviceProviderService.setAgents(res.body?.states?.data);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.states = [];
        },
      });
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
